<template>
  <div class="">
    <div class="flex flex-row flex-no-wrap justify-between h-32 mt-4 py-4 px-4 w-full" v-if="!loading" style="background-color: #fff;">
      <div class="total_orders flex flex-row justify-start content-center">
        <i class="p-4 el-icon-shopping-bag-2 text-5xl text-white rounded-lg shadow-2xl mr-4"></i>
        <AggregatesInfo :details="{
          aggregate_name: 'Total Order',
          total: aggregates.total_orders,
          change: aggregates.orders_percentage_change
        }" />
      </div>
      <div class="total_product flex flex-row justify-start">
        <i class="p-4 el-icon-box text-5xl text-white rounded-lg shadow-2xl mr-4"></i>
        <AggregatesInfo :details="{aggregate_name: 'Total Products', total: aggregates.total_products, change: aggregates.products_percentage_change}" />
      </div>
      <div class="total_feedback flex flex-row justify-start">
        <i class="p-4 el-icon-chat-line-round text-5xl text-white rounded-lg shadow-2xl mr-4"></i>
        <AggregatesInfo :details="{aggregate_name: 'Total Feedback', total: aggregates.total_feedbacks, change: aggregates.feedbacks_percentage_change}" />
      </div>
      <div class="total_sold flex flex-row justify-start">
        <i class="p-4 el-icon-bank-card text-5xl text-white rounded-lg shadow-2xl mr-4"></i>
        <AggregatesInfo :details="{aggregate_name: 'Total Sold', total: aggregates.total_sold, change: aggregates.sold_percentage_change}" />
      </div>
    </div>
    <div class="flex flex-row flex-no-wrap justify-between bg-white h-32 mt-8 py-6 px-10 w-full" v-else>
      <AggregatesLoader v-for="n in 4" />
    </div>
  </div>

</template>

<script>
import AggregatesInfo from './includes/aggregates_info.vue';
import AggregatesLoader from './loaders/aggregates_loader.vue';

export default {
  name: 'aggregates',
  components: {
    AggregatesInfo,
    AggregatesLoader,
  },
  data() {
    return {
      details: {
        aggregate_name: 'Total Orders',
        total: 3000,
        change: 0.67,
      },
      loading: true,
    };
  },
  computed: {
    aggregates() {
      return this.$store.state.Dashboard.aggregate;
    },
  },
  async mounted() {
    // Dispatch API call to get totals
    this.loading = true;
    await this.$store.dispatch('Dashboard/fetchTotals');
    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
.total_orders,
.total_feedback,
.total_product,
.total_sold {
  flex: 0 1 23%;
}
.total_orders {
  i {
    background-image: linear-gradient(to top, #296ef9, #4439e4);
    background-position: center;
    flex: 0 1 20%;
  }
}
.total_product {
  i {
    background-image: linear-gradient(to top, #fd1b57, #ff7c90);
    background-position: center;
    flex: 0 1 20%;
  }
}
.total_feedback {
  i {
    background-image: linear-gradient(to top, #3f89ea, #55d4ff);
    background-position: center;
    flex: 0 1 20%;
  }
}
.total_sold {
  i {
    background-image: linear-gradient(to top, #47a62d, #94f587);
    background-position: center;
    flex: 0 1 20%;
  }
}
</style>
